import React from "react";
import Accordion from "@material-ui/core/Accordion";
import Icon from "../../../common/components/Icon/Icon";
import LAccordionDetails from "./LAccordionDetails";
import LAccordionSummary from "./LAccordionSummary";

//styles
import styles from "./LAccordion.module.scss";
import cx from "classnames";

interface ILAccordion {
    id?: string;
    name: string;
    expanded: boolean;
    disabled?: boolean;
    size: "large" | "small";
    headerAlign?: "center" | "top";
    handleChange: (panel: string, isExpanded: boolean) => void;
    summary: () => React.ReactNode;
    onEntered?: () => void;
    onExited?: () => void;
    className?: string;
}

/*
    Adapted from:
    =============
    https://material-ui.com/components/accordion/#controlled-accordion
*/

const LAccordion: React.FC<ILAccordion> = (props) => {
    const {
        id,
        disabled,
        expanded,
        name,
        headerAlign,
        onEntered,
        onExited,
        handleChange,
        summary,
        className,
        children
    } = props;

    const size: ILAccordion["size"] = props.size || "small";

    const iconClassNames = cx({
        [styles["icon--small"]]: size === "small",
        [styles["icon--large"]]: size === "large"
    });

    return (
        <Accordion
            id={id}
            disabled={disabled}
            expanded={expanded}
            onChange={(e, isExpanded) => handleChange(name, isExpanded)}
            classes={{
                root: cx({
                    [styles["accordion-root"]]: true,
                    [styles["accordion-size--small"]]: size === "small",
                    [styles["accordion-size--large"]]: size === "large",
                    [className]: !!className
                })
            }}
            // We unmount on Exit as we have complex object in accordions (Family, Settings, Results etc.)
            // So we can limit the amount of objects in the virtual DOM
            TransitionProps={{
                unmountOnExit: true,
                onEntered,
                onExited
            }}>
            <LAccordionSummary
                expandIcon={
                    props.expanded ? (
                        <Icon id="AccordionMinus" className={iconClassNames} />
                    ) : (
                        <Icon id="AccordionPlus" className={iconClassNames} />
                    )
                }
                headerAlign={headerAlign}
                size={size}>
                {summary()}
            </LAccordionSummary>
            <LAccordionDetails>{children}</LAccordionDetails>
        </Accordion>
    );
};

export default LAccordion;
